// extracted by mini-css-extract-plugin
module.exports = {"pulse":"hotspot_pulse__FsYG_"};